export default "__VITE_ASSET__CMDA7hvI__"